/* globals document navigator $ */

import userLocationEvents from './events';
import range from './range';
import rangeEvents from './range/events';
import factory from '../../../components/factory';

/**
 * Location
 * @param {Element} element
 * @return {Object}
 */
const userLocation = (element) => {
  const defaultDistance = 5;
  const distanceSettings = { value: defaultDistance, min: 0, max: 10, range: 'min', step: 0.1, disabled: true };
  const typeTimeoutDuration = 1000;

  const zipcodeElement = element.querySelector('[data-js-zipcode]');
  const distanceElement = element.querySelector('[data-js-range]');
  const currentLocation = document.getElementById('currentLocation');

  const $element = $(element);
  const $zipcode = $(zipcodeElement);
  const $distance = $(distanceElement);
  const $currentLocation = $(currentLocation);

  let hasCoordinates = false;
  let coordinates = {};
  let distanceValue = defaultDistance * 1000;
  let hasZipcode = false;
  let zipcodeValue = '';
  let typeTimeout;

  /**
   * Constructor
   */
  function constructor() {
    factory(range, '[data-js-range]', distanceSettings);

    if (!navigator.geolocation) {
      $currentLocation.closest('.form__element').remove();
    }

    bindEvents();
  }

  /**
   * Bind handlers to events
   */
  function bindEvents() {
    $element.on(userLocationEvents.CLEAR, onClear);
    $zipcode.on('keyup keypress paste blur', onZicodeChange);
    $distance.on(rangeEvents.CHANGE, onDistanceChange);
    $currentLocation.on('change', onCurrentLocationChange);
  }

  /**
   * Zipcode change event handler
   * @param {Event} event
   */
  function onZicodeChange(event) {
    const isReturnKey = event.keyCode === 13;

    if (isReturnKey) {
      event.preventDefault();
    }

    if (typeTimeout) {
      clearTimeout(typeTimeout);
    }

    typeTimeout = setTimeout(() => onZipcodeDoneChanging($zipcode), typeTimeoutDuration);
  }

  /**
   * Zipcode done typing event handler
   * @param {jQuery element} $zipcode
   */
  function onZipcodeDoneChanging($zipcode) {
    if (!typeTimeout) {
      return;
    }

    const zipcode = $zipcode.val().replace(/\s+/g, '');

    typeTimeout = null;
    hasZipcode = !!zipcode;
    zipcodeValue = zipcode;

    $distance.trigger(hasZipcode ? rangeEvents.ENABLE : rangeEvents.DISABLE);
    triggerChange();
  }

  /**
   * Trigger change event
   */
  function triggerChange() {
    const distance = distanceValue;
    const eventData = { hasZipcode, hasCoordinates, distance };

    if (hasZipcode) {
      eventData.zipcode = zipcodeValue;
    }

    if (hasCoordinates) {
      eventData.latitude = coordinates.latitude;
      eventData.longitude = coordinates.longitude;
    }

    $element.trigger(userLocationEvents.CHANGE, eventData);
  }

  /**
   * Distance change event handler
   * @param {Event} event
   * @param {Object} eventData
   */
  function onDistanceChange(event, eventData) {
    if (hasZipcode) {
      distanceValue = eventData.value * 1000;
      triggerChange();
    }
  }

  /**
   * Geolocation success event handler
   * @param {Object} location
   */
  function onGeolocationSuccess({ coords }) {
    if (coords.latitude) {
      hasCoordinates = true;
      coordinates = coords;
      $distance.trigger(rangeEvents.ENABLE);
      triggerChange();
    }
  }

  /**
   * Geolocation failed event handler
   */
  function onGeolocationFailed() {
    currentLocation.checked = false;
  }

  /**
   * Current location change event handler
   */
  function onCurrentLocationChange() {
    const options = { enableHighAccuracy: false, maximumAge: 600000, timeout: 27000 };

    if (currentLocation.checked) {
      navigator.geolocation.getCurrentPosition(onGeolocationSuccess, onGeolocationFailed, options);
    } else {
      hasCoordinates = false;
      coordinates = {};
      $distance.trigger(rangeEvents.DISABLE);
    }
  }

  /**
   * Clear event handler
   */
  function onClear() {
    zipcodeValue = '';
    hasZipcode = !!zipcodeValue;
    $zipcode.val(zipcodeValue);

    currentLocation.checked = false;
    hasCoordinates = false;
    coordinates = {};

    $distance.trigger(rangeEvents.DISABLE);
  }

  constructor();

  return {};
};

export default userLocation;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/filters/userLocation/userLocation.js